import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import ProductsPage from '../views/ProductsPage.vue';
import CategoryPage from '../views/CategoryPage.vue';
import ProductDetailPage from '../views/ProductDetailPage.vue';
import CartPage from '../views/CartPage.vue';
import CheckoutPage from '../views/CheckoutPage.vue';
import PaymentPage from '../views/PaymentPage.vue';
import OrderTrackingPage from '../views/OrderTrackingPage.vue';
import MemberLoginPage from '../views/MemberLoginPage.vue';
import MemberRegisterPage from '../views/MemberRegisterPage.vue';
import MemberOrdersPage from '../views/MemberOrdersPage.vue';
import MemberProfilePage from '../views/MemberProfilePage.vue';
import MemberOrderDetailPage from '../views/MemberOrderDetailPage.vue';

// Admin Views
import AdminLoginPage from '../views/admin/LoginPage.vue';
import AdminLayout from '../views/admin/AdminLayout.vue';
import DashboardPage from '../views/admin/DashboardPage.vue';
import AdminProductsPage from '../views/admin/ProductsPage.vue';
import ProductFormPage from '../views/admin/ProductFormPage.vue';
import OrdersPage from '../views/admin/OrdersPage.vue';
import OrderDetailPage from '../views/admin/OrderDetailPage.vue';
import CategoriesPage from '../views/admin/CategoriesPage.vue';
import CategoryFormPage from '../views/admin/CategoryFormPage.vue';
import ReportsPage from '../views/admin/ReportsPage.vue';
import SettingsPage from '../views/admin/SettingsPage.vue';

import { useAuthStore } from '../stores/auth';
import { useAdminAuthStore } from '../stores/adminAuth';

const routes = [
  // Customer Routes
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/products',
    name: 'Products',
    component: ProductsPage
  },
  {
    path: '/category/:slug',
    name: 'Category',
    component: CategoryPage
  },
  {
    path: '/product/:slug',
    name: 'ProductDetail',
    component: ProductDetailPage
  },
  {
    path: '/cart',
    name: 'Cart',
    component: CartPage
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: CheckoutPage
  },
  {
    path: '/order/:orderNumber',
    name: 'Payment',
    component: PaymentPage
  },
  {
    path: '/track',
    name: 'TrackOrder',
    component: OrderTrackingPage
  },
  {
    path: '/tracking/:orderNumber',
    name: 'TrackingResult',
    component: OrderTrackingPage,
    beforeEnter: (to, from, next) => { next(); }
  },
  {
    path: '/login',
    name: 'Login',
    component: MemberLoginPage
  },
  {
    path: '/register',
    name: 'Register',
    component: MemberRegisterPage
  },
  {
    path: '/member/orders',
    name: 'MemberOrders',
    component: MemberOrdersPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/member/profile',
    name: 'MemberProfile',
    component: MemberProfilePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/member/orders/:orderNumber',
    name: 'MemberOrderDetail',
    component: MemberOrderDetailPage,
    meta: { requiresAuth: true }
  },

  // Admin Routes
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLoginPage
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAdmin: true },
    children: [
        {
            path: '',
            redirect: '/admin/dashboard'
        },
        {
            path: 'dashboard',
            name: 'AdminDashboard',
            component: DashboardPage
        },
        {
            path: 'products',
            name: 'AdminProducts',
            component: AdminProductsPage
        },
        {
            path: 'products/create',
            name: 'AdminProductCreate',
            component: ProductFormPage
        },
        {
            path: 'products/:id/edit',
            name: 'AdminProductEdit',
            component: ProductFormPage
        },
        {
            path: 'categories',
            name: 'AdminCategories',
            component: CategoriesPage
        },
        {
            path: 'categories/create',
            name: 'AdminCategoryCreate',
            component: CategoryFormPage
        },
        {
            path: 'categories/:id/edit',
            name: 'AdminCategoryEdit',
            component: CategoryFormPage
        },
        {
            path: 'orders',
            name: 'AdminOrders',
            component: OrdersPage
        },
        {
            path: 'orders/:id',
            name: 'AdminOrderDetail',
            component: OrderDetailPage
        },
        {
            path: 'reports',
            name: 'AdminReports',
            component: ReportsPage
        },
        {
            path: 'settings',
            name: 'AdminSettings',
            component: SettingsPage
        },
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();
    const adminAuthStore = useAdminAuthStore();

    if (to.meta.requiresAdmin) {
        if (!adminAuthStore.isAuthenticated) {
            next('/admin/login');
        } else {
            next();
        }
    } else if (to.meta.requiresAuth) {
        if (!authStore.isAuthenticated) {
            next('/login');
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
